import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';
import { Store, ChevronRight, Eye, Heart, MapPin } from 'lucide-react';
import { useMosque } from '../contexts/MosqueContext';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const PasarPage = () => {
  const navigate = useNavigate();
  const { mosqueId, to } = useMosque();
  const [shops, setShops] = useState([]);

  useEffect(() => {
    axios.get(`${API_URL}/api/umkm`, { params: { mosque_id: mosqueId } })
      .then(({ data }) => setShops(data)).catch(() => setShops([]));
  }, [mosqueId]);

  return (
    <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} className="min-h-screen bg-[#F8F9FA] px-6 py-8 pb-24">
      <div className="mb-8">
        <h1 className="text-4xl font-heading font-bold tracking-tight text-primary-dark mb-2">Pasar UMKM</h1>
        <p className="text-sm font-body text-text-secondary">Dukung usaha jamaah masjid</p>
      </div>

      {shops.length === 0 ? (
        <div className="bg-white rounded-3xl border border-stone-100 p-12 text-center">
          <Store className="w-14 h-14 text-stone-300 mx-auto mb-4" />
          <p className="text-text-secondary font-body">Belum ada iklan UMKM</p>
        </div>
      ) : (
        <div className="space-y-3">
          {shops.map((shop, index) => {
            const cover = (shop.images && shop.images[0]) || shop.logo_url;
            return (
              <motion.button
                key={shop.id}
                initial={{ opacity: 0, y: 16 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: 0.04 * index }}
                onClick={() => navigate(to(`/pasar/${shop.id}`))}
                whileTap={{ scale: 0.98 }}
                className="w-full text-left bg-white rounded-2xl border border-stone-100 shadow-sm hover:shadow-md transition-shadow flex items-center gap-3 p-3"
                data-testid={`umkm-card-${shop.id}`}
              >
                <div className="w-16 h-16 rounded-xl bg-cover bg-center flex-shrink-0 bg-emerald-50" style={{ backgroundImage: cover ? `url('${cover}')` : 'none' }}>
                  {!cover && <div className="w-full h-full flex items-center justify-center"><Store className="w-7 h-7 text-emerald-300" /></div>}
                </div>
                <div className="flex-1 min-w-0">
                  <h3 className="text-base font-body font-semibold text-text-primary truncate mb-0.5">{shop.name}</h3>
                  <div className="flex items-center gap-2 mb-1">
                    <span className="inline-block px-2 py-0.5 rounded-full bg-amber-50 text-amber-700 text-[11px] font-medium">{shop.category}</span>
                    {shop.location && <span className="flex items-center gap-0.5 text-[11px] text-stone-400"><MapPin className="w-3 h-3" />{shop.location}</span>}
                  </div>
                  <p className="text-xs font-body text-text-secondary line-clamp-1">{shop.description}</p>
                </div>
                <div className="flex flex-col items-end gap-1.5 self-stretch justify-between py-1">
                  <span className="flex items-center gap-1 text-[11px] font-body text-rose-500"><Heart className="w-3.5 h-3.5" />{shop.likes || 0}</span>
                  <span className="flex items-center gap-1 text-[11px] font-body text-stone-400"><Eye className="w-3.5 h-3.5" />{shop.view_count || 0}</span>
                  <ChevronRight className="w-5 h-5 text-emerald-600" />
                </div>
              </motion.button>
            );
          })}
        </div>
      )}
    </motion.div>
  );
};

export default PasarPage;
